import React, { useContext } from "react"
import AskQuestionModal from "./Modal"
import { SpaceProfileContext } from "../context"
import {
  longPriceForOffices,
  pricePerDesk,
} from "../../../utils/formattedPrices"
import isDd from "../../../utils/isDd"

export default ({
  space = {},
  spaceSummary = {},
  isCms = false,
  toEmail = null,
}) => {
  const {
    commonData: { getInTouch, filteredOptions, displayPrice },
    actions: { setGetInTouch },
  } = useContext(SpaceProfileContext)
  const toggleAskQuestion = () => setGetInTouch(!getInTouch)

  const isDedicatedDesk = isDd(spaceSummary.space_type)

  return (
    <div className="space-profile-contact-section">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-lg-6">
            <h2>Have a question about this space?</h2>
            <p>
              We'll connect you directly to a Workplace One space advisor who
              can help you answer any question that you may have before touring
              the space
            </p>
            <button className="btn btn-sp-profile" onClick={toggleAskQuestion}>
              Get in Touch
            </button>
          </div>
        </div>
      </div>
      <AskQuestionModal
        toggle={toggleAskQuestion}
        show={getInTouch}
        image={space.hero_image_url}
        space={space}
        total_price={`${longPriceForOffices(filteredOptions)}`}
        displayPrice={displayPrice}
        toEmail={toEmail}
        price_per_desk={
          isDedicatedDesk ? `${pricePerDesk(filteredOptions)}` : null
        }
        isCms={isCms}
      />
    </div>
  )
}
